module.exports = __webpack_public_path__ + "static/media/team1.9b255388.jpg";